import {BaseApiService} from "../../../infrastructure/domain-services/base-api-service";
import {PartialGameFactory} from "./partial-game.factory";
import {PartialGameRequestParams} from "../models/partial-game.request-params";
import {BaseUtilsService} from "../../../infrastructure/domain-services/base-utils-service";

export class PartialGameApiService extends BaseApiService {
  static injectables = [...BaseUtilsService.injectables, PartialGameFactory];

  _updateResponse(request: PartialGameRequestParams, params: PartialGameRequestParams, isFullDeltaResponse: Boolean) {
    request.params.showOdds = params.showOdds;

    return super._updateResponse(request, params, isFullDeltaResponse)
  }
}
